import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "@/lib/oneyork";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-36 bg-[#050505]"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="mb-14">
          <span className="text-xs uppercase tracking-[0.28em] text-[#d4af37] font-medium">
            FAQ
          </span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Questions,{" "}
            <span className="italic font-medium text-white/70">answered.</span>
          </h2>
        </div>

        <div className="border-t border-white/10">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-6 py-6 lg:py-7 text-left group"
                >
                  <span
                    className={`font-display text-lg sm:text-xl tracking-tight transition-colors ${
                      isOpen
                        ? "text-[#d4af37]"
                        : "text-white group-hover:text-[#d4af37]"
                    }`}
                  >
                    {item.q}
                  </span>
                  {isOpen ? (
                    <Minus
                      className="text-[#d4af37] shrink-0"
                      size={22}
                      strokeWidth={1.5}
                    />
                  ) : (
                    <Plus
                      className="text-white/60 shrink-0 group-hover:text-[#d4af37] transition-colors"
                      size={22}
                      strokeWidth={1.5}
                    />
                  )}
                </button>
                <div
                  className={`grid transition-all duration-500 ease-out ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100 pb-6"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-white/65 leading-relaxed max-w-2xl">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
